module.exports = __webpack_public_path__ + "media/newstyle/images/quadrado-white-34b57b7a7e8d19dbfb2597460a88ed97.svg";